import React, { useState, useEffect } from 'react';
import Icon from '@prism/icon';
import Button from '@prism/button';
import classNames from 'classnames';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/* eslint-disable import/prefer-default-export */
var getConstrainedBounds = function getConstrainedBounds(currentPage, totalPages, rangeLength) {
  var leftBound = 1;
  var rightBound = 1;

  if (totalPages <= rangeLength) {
    rightBound = totalPages;
  } else {
    var leftOffset = Math.max(1, currentPage - Math.floor(rangeLength / 2));
    var rightOffset = Math.min(totalPages, leftOffset + rangeLength - 1);

    if (rightOffset === totalPages && totalPages - rangeLength > 0) {
      leftBound = rightOffset - rangeLength + 1;
    } else {
      leftBound = leftOffset;
    }

    rightBound = rightOffset;
  }

  return {
    rightBound: rightBound,
    leftBound: leftBound
  };
};

var rangeLength = 5;

var usePagination = function usePagination(props) {
  var currentPage = props.currentPage,
      totalPages = props.totalPages,
      onChange = props.onChange;

  var _useState = useState(currentPage),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      range = _useState4[0],
      setRange = _useState4[1];

  var getRange = function getRange(page) {
    var _getConstrainedBounds = getConstrainedBounds(page, totalPages, rangeLength),
        rightBound = _getConstrainedBounds.rightBound,
        leftBound = _getConstrainedBounds.leftBound;

    var length = rightBound - leftBound + 1;
    var returnArray = [];

    for (var i = 0; i < length; i += 1) {
      var pageItem = i + leftBound;
      var pageNumberClasses = classNames('pagination__control', 'pagination__control--page', ["pagination__control--page-".concat(pageItem)], pageItem === page && 'selected', totalPages === 0 && 'd-none');
      returnArray.push({
        pageNumberClasses: pageNumberClasses,
        pageItem: pageItem
      });
    }

    return returnArray;
  };

  var updateIndex = function updateIndex(newIndex) {
    var updatedIndex = {
      prevIndex: currentIndex,
      index: newIndex
    };
    setCurrentIndex(newIndex);
    var rangeArray = getRange(newIndex);
    setRange(rangeArray);
    onChange(updatedIndex);
  };

  useEffect(function () {
    if (currentPage !== currentIndex) {
      setCurrentIndex(currentPage);
    }

    var rangeArray = getRange(currentPage);
    setRange(rangeArray);
  }, [currentPage]);

  var getControlClasses = function getControlClasses(control) {
    return classNames('pagination__control', control && "pagination__control--".concat(control), totalPages === 0 && 'd-none');
  };

  return {
    updateIndex: updateIndex,
    getControlClasses: getControlClasses,
    totalPages: totalPages,
    currentIndex: currentIndex,
    range: range
  };
};

var Pagination = function Pagination(props) {
  var _usePagination = usePagination(props),
      currentIndex = _usePagination.currentIndex,
      totalPages = _usePagination.totalPages,
      getControlClasses = _usePagination.getControlClasses,
      updateIndex = _usePagination.updateIndex,
      range = _usePagination.range;

  var btnProps = {
    variant: 'textonly',
    size: 'sm'
  };

  var handleFirstPageClick = function handleFirstPageClick() {
    return updateIndex(1);
  };

  var handlePrevPageClick = function handlePrevPageClick() {
    return updateIndex(currentIndex - 1);
  };

  var handleNextPageClick = function handleNextPageClick() {
    return updateIndex(currentIndex + 1);
  };

  var handlePageClick = function handlePageClick(page) {
    updateIndex(page);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "pagination"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    disabled: currentIndex === 1,
    onClick: handleFirstPageClick,
    className: getControlClasses('start'),
    title: "Go to page 1"
  }, btnProps), /*#__PURE__*/React.createElement(Icon, {
    glyph: "back-to-start"
  })), /*#__PURE__*/React.createElement(Button, _extends({
    disabled: currentIndex === 1,
    onClick: handlePrevPageClick,
    className: getControlClasses('prev'),
    title: "Go to previous page"
  }, btnProps), /*#__PURE__*/React.createElement(Icon, {
    glyph: "chevron-left-light"
  })), range && range.map(function (item) {
    return /*#__PURE__*/React.createElement(Button, _extends({
      key: item.pageItem,
      disabled: item.pageItem === currentIndex,
      title: item.pageItem === currentIndex ? "You are on page ".concat(item.pageItem) : "Go to page ".concat(item.pageItem),
      className: item.pageNumberClasses,
      onClick: function onClick() {
        return handlePageClick(item.pageItem);
      }
    }, btnProps), item.pageItem);
  }), /*#__PURE__*/React.createElement(Button, _extends({
    disabled: currentIndex === totalPages,
    onClick: handleNextPageClick,
    className: getControlClasses('next'),
    title: "Go to next page"
  }, btnProps), /*#__PURE__*/React.createElement(Icon, {
    glyph: "chevron-right-light"
  })));
};

Pagination.defaultProps = {
  currentPage: 1,
  totalPages: 1,
  onChange: function onChange() {}
};

export { Pagination as default };
//# sourceMappingURL=index.js.map
